import { render, staticRenderFns } from "./RubricHome.vue?vue&type=template&id=4a5c5d6f"
import script from "./RubricHome.vue?vue&type=script&lang=js"
export * from "./RubricHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports